import React, {useEffect} from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import HomeHero from '../../components/Home/HomeHero';
import HomeDesc from '../../components/Home/HomeDesc';
import HomeSoftwareCallout from '../../components/Home/HomeSoftwareCallout';
import HomeNews from '../../components/Home/HomeNews';
import HomeNewsletter from '../../components/Home/HomeNewsletter';
import HomeExplore from '../../components/Home/HomeExplore';
import HomeAction from '../../components/Home/HomeAction';
import HomeSoftware from '../../components/Home/HomeSoftware';
import HomeResources from '../../components/Home/HomeResources';

const Home = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ Quality Indicators`;
      });
    return (<>
        <HomeHero />
        <HomeDesc />
        <HomeSoftwareCallout />
        <HomeNews />
        <HomeNewsletter />
        <HomeExplore />
        <HomeAction />
        <HomeSoftware />
        <HomeResources />
    </>
    )
}

export default Home;